import { Flex, Typography } from 'antd';
import { MInput, MSelect } from '@Components/Base';
import { OptionNum } from '@Components/types/options';

import styles from './fields-styles.module.css';

interface SimCardFieldsProps {
  simCapValues: OptionNum[];
  simCardRequest: 'Input' | 'Dropdown' | '';
  setValues: React.Dispatch<
    React.SetStateAction<{
      reqCapValue: number;
      mobileNumber: string;
    }>
  >;
  selectedValue: number;
}

const SimCardFields: React.FC<SimCardFieldsProps> = ({
  simCapValues,
  setValues,
  simCardRequest,
  selectedValue,
}) => {
  return (
    <div className={styles.container}>
      <Flex vertical gap={16}>
        {simCardRequest === 'Input' && (
          <Flex vertical>
            <Typography.Text>Mobile Number:</Typography.Text>
            <MInput
              name="mobileNumber"
              onChange={(input) => {
                setValues((prev) => {
                  return { ...prev, mobileNumber: input.target.value };
                });
              }}
              placeholder="Type Mobile Number"
            />
          </Flex>
        )}

        {simCardRequest === 'Dropdown' && (
          <Flex vertical>
            <Typography.Text>SIM Card Credit Limit:</Typography.Text>
            <MSelect
              options={simCapValues}
              onChange={(selectValue) => {
                setValues((prev) => {
                  return { ...prev, reqCapValue: selectValue };
                });
              }}
              value={selectedValue}
              placeholder="Choose SIM Card Credit Limit"
            />
          </Flex>
        )}
      </Flex>
    </div>
  );
};

export default SimCardFields;
